export default __webpack_public_path__ + "static/media/checkDangerBadge.5d29b817.svg";